import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient, AgentService, AgentServicesClient, BankDetails, DeliverService, DeliverServicesClient, NServices, ServiceClient } from "src/app/web-api-client";

@Component({
  selector: 'app-agentService-edit',
  templateUrl: './agentService-edit.component.html',
  styleUrls: ['./agentService-edit.component.scss']
})
export class AgentServiceEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: AgentService;
  public services: NServices[];
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: AgentServicesClient, public serviceClient:ServiceClient) { }

  ngOnInit(): void {
    this.serviceClient.getList().subscribe(services => {

      this.services = services;
      this.initializeForm();
      this.isLoaded = true;

    })
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      agentCommission: [this.editObject.agentCommission, Validators.required],
      service: [this.editObject.idService, Validators.required],
      isActive: [this.editObject.isActive, Validators.required]
    });
  }

  onSubmit() {
    if (this.Form.valid) {

      this.editObject.title = this.Form.value.title;
      this.editObject.agentCommission = this.Form.value.agentCommission;

      this.editObject.idService = this.Form.value.service;
      this.editObject.service = null;
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public isSelected(service:NServices) {
    let result = this.editObject.idService == service.idService;
    return result;
  }

  onBankAccountSelected(bankAccount:BankDetails) {
    this.editObject.idBankDetails = bankAccount.idBankDetails;

  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }



}
